export { default } from "bullitttime-embermodelsgochips/adapters/statistic";
